import { createSelector } from "reselect"

const selectGroup = state => state.slackIntegration

export const selectSlackIntegrationInfo = createSelector(
  selectGroup,
  state => state.slackIntegrationInfo
)
